import { render, staticRenderFns } from "./GuidaOperatore.vue?vue&type=template&id=f5afbada"
import script from "./GuidaOperatore.vue?vue&type=script&lang=js"
export * from "./GuidaOperatore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports